import getParticipantTemplate from "./ParticipantTemplate";
import Const from "../../constants/Constants";
var $ = window.$ || {};

class ParticiantView{
	constructor(model, callback)
	{
		this._model = model;
		this._parent = $("#hostParticipantStreamsList");
		this._id = model.id;
		this._name = model.firstName;
		this._order = model.order;
		this.callback = callback;
		this._appearanceArr = [];
		this._firstLetter = model.firstName.substring(0, 1).toUpperCase();
		this._lastLetter =model.lastName.substring(0, 1).toUpperCase();
	}
	render(){
		var str = getParticipantTemplate({id:this._id, name:this._name, order:this._order, initials:this._firstLetter+this._lastLetter});
		console.log('***********************************');
		console.log(this._parent);
		this._parent.append(str);
		this._addEvents();
		if(!this._model.isVisible){
			this._el.addClass("d-none");
		}
	}

	destroy(){
		this._el = '';
	}
	
	_addEvents(){

		this._el = $("#participant_agora"+this._id);
		this._el.find(".close-model-btn").click(this._disableZoom.bind(this));
		this._el.find(".click-zoom").click(this._enableZoom.bind(this));

		this._el.find(".hand-icon").click(this._onRaiseHandClickHandler.bind(this));
		this._el.find(".microphone-icon").click(this._onclickaudioOff.bind(this));
		this._el.find(".video-streams").click(this._onStreamClickHandler.bind(this));
		this._el.find(".eject-session").click(this._onEjectHandler.bind(this));
		this._el.find(".unmute-audio").click(this._onMuteParticipant.bind(this));
		this._el.find(".mute-audio").click(this._onUnmuteParticipant.bind(this));

	}
	_onclickaudioOff()
	{
		this.callback(Const.AUDIO_CLICKED_ON_BOX, this._id);
	}
	_onRaiseHandClickHandler(show){
		this.callback(Const.RAISE_HAND_CLICKED_ON_BOX, this._id);
	}
	_onStreamClickHandler(){
		this.callback(Const.STREAM_CLICKED_ON_BOX, this._id);
	}
	_onEjectHandler(){
		this.callback(Const.STREAM_EJECT_ON_BOX, this._id);
	}
	_onMuteParticipant(){
		this.callback(Const.STREAM_MUE_MIC, this._id);
	}
	_onUnmuteParticipant(){
		this.callback(Const.STREAM_UNMUE_MIC, this._id);
	}

	resetMarquee() {
		this._el = $("#participant_agora"+this._id);
	}
	show(){
		this._el.removeClass("d-none");
	}

	swapOrder(swapWith){
		this._el = $("#participant_agora"+this._id);
		let swapToOrder 	= parseInt($('#participant_agora'+swapWith).css("order"));
	  	let swapFromOrder 	= parseInt(this._el.css("order"));

	  	this._el.css('order', swapToOrder);
	  	$('#participant_agora'+swapWith).css('order', swapFromOrder);

	  	if ($('#'+swapWith).hasClass('remote_video_selected')) {
	      	$('#'+this._id).addClass('remote_video_selected');
	      	$('#'+swapWith).removeClass('remote_video_selected');
	  	}
	}

	displayEmoji(apprearance){
		this._el = $("#participant_agora"+this._id);
		if(this._appearanceArr.indexOf(apprearance) == -1){
			let clone = this._el.find(".icon-tocopy").clone();
			clone.addClass("icon-"+apprearance).removeClass('d-none');
			this._el.find(".vid-icons").append(clone);
			this._appearanceArr.push(apprearance);
		}
	}

	_enableZoom(){
		if (this._el.find('.video-holder').hasClass('zoom-video')) {
	        this._el.find('.video-holder').removeClass('zoom-video');
    		this._el.find('.video-holder').find('i').removeClass('fa-search-minus');
	    } else {
	    	this._el.find('.video-holder').addClass('zoom-video');
	        this._el.find('.video-holder').find('i').addClass('fa-search-minus');
	    }
	}
	_disableZoom(){
        this._el.find('.video-holder').removeClass('zoom-video');
        this._el.find('.video-holder').find('i').removeClass('fa-search-minus');
	}
}

export default ParticiantView;